// The not-found page (05-routes-links.md, "Not found"): beside the rail when signed in, the whole
// window otherwise; never a protocol error and never an attempt to join anything.
import { useEffect, useRef } from 'react';
import logo from '../assets/logo.svg';
import { Button } from '../blocks/Button';
import { navigate } from '../core/router';
import { t } from '../i18n';

export function NotFound({ alone }: { alone?: boolean }) {
  const home = useRef<HTMLButtonElement>(null);
  useEffect(() => home.current?.focus(), []);
  return (
    <main className={alone ? 'not-found alone' : 'not-found'} data-desyr-not-found="">
      <img src={logo} alt={t('signin.logo')} width={56} height={56} />
      <h1>{t('notFound.title')}</h1>
      <p>{t('notFound.line')}</p>
      <Button ref={home} variant="filled" onClick={() => navigate('/home/', { replace: true })}>
        {t('common.goHome')}
      </Button>
    </main>
  );
}
